import { render, staticRenderFns } from "./newly.vue?vue&type=template&id=1a8d93d2&scoped=true"
import script from "./newly.vue?vue&type=script&lang=js"
export * from "./newly.vue?vue&type=script&lang=js"
import style0 from "./newly.vue?vue&type=style&index=0&id=1a8d93d2&prod&lang=less"
import style1 from "./newly.vue?vue&type=style&index=1&id=1a8d93d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8d93d2",
  null
  
)

export default component.exports